import React, { useEffect } from 'react';
import AttributesTable from './AttributesTable';
import AttributesTopBar from '../AttributesTopBar/AttributesTopBar';
import {
  getAttributes,
  getAttributesCategories,
  getLanguages,
} from '../../redux/actions/attributesActions';
import {
  newAttribute,
  editAttribute,
  viewAttribute,
} from '../../redux/actions/focusedAttributeActions';
import { RootStateOrAny, useDispatch, useSelector } from 'react-redux';
import EmptyBody from './EmptyBody';
import EditAttributeDialog from '../AttributesDialog/components/EditAttributeDialog';
import NewAttributeDialog from '../AttributesDialog/components/NewAttributeDialog';
import ViewAttributeDialog from '../AttributesDialog/components/ViewAttributeDialog';

const AttributesTab = () => {
  const { attributeList: attributes } = useSelector(
    (state: RootStateOrAny) => state.AttributesReducer,
  );

  const { selectedBrand } = useSelector(
    (state: RootStateOrAny) => state.UIReducer,
  );

  const dispatch = useDispatch();

  useEffect(() => {
    dispatch(getAttributesCategories);
    dispatch(getLanguages);
    dispatch(getAttributes({ brand: selectedBrand }));
  }, [dispatch, selectedBrand]);

  const handleNewAttribute = () => {
    dispatch(newAttribute());
  };

  const handleEditAttribute = (id: number) => {
    console.log(`Editing attribute ${id}`);
    dispatch(editAttribute(id));
  };
  
  const handleViewAttribute = (id: number) => {
    console.log(`Viewing attribute ${id}`);
    dispatch(viewAttribute(id));
  }

  return (
    <div>
      {attributes && attributes.data?.length > 0 ? (
        <>
          <AttributesTopBar onNewAttribute={handleNewAttribute} />
          <AttributesTable
            onEditAttribute={(id: number) => handleEditAttribute(id)}
            onViewAttribute={(id: number) => handleViewAttribute(id)}
          />
        </>
      ) : (
        <EmptyBody onNewAttribute={handleNewAttribute} />
      )}

      <EditAttributeDialog />
      <ViewAttributeDialog />
      <NewAttributeDialog />
    </div>
  );
};

export default AttributesTab;
